import React, { Component } from 'react';
import PropTypes from 'prop-types';
import interact from 'interactjs';

export default class Draggable extends Component {
  static latLng(e, overlayView, offset) {
    const point = new google.maps.Point(e.pageX - offset.left, e.pageY - offset.top);
    return overlayView.getProjection().fromContainerPixelToLatLng(point);
  }

  constructor(props) {
    super(props);
    this.initDraggable = this.initDraggable.bind(this);
  }

  initDraggable(elem) {
    if (!elem) { return; }
    interact(elem).draggable({
      onstart: (e) => { this.props.onDragStart(e); },
      onmove: ({ target, dx, dy }) => {
        const $target = $(target);
        const x = ($target.data('x') || 0) + dx;
        const y = ($target.data('y') || 0) + dy;

        // translate the element
        $target.css('transform', `translate(${x}px, ${y}px)`);

        // update the position attributes
        $target.data('x', x);
        $target.data('y', y);
      },
      onend: (e) => {
        this.props.onDragEnd(e, this.props.object);
        $(elem).css('transform', '').data({ x: 0, y: 0 });
      },
    });
  }

  render() {
    return (
      <div ref={this.initDraggable}>
        {this.props.children}
      </div>
    );
  }
}

Draggable.defaultProps = {
  onDragEnd: () => {},
  onDragStart: () => {},
  object: null,
};

Draggable.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
  ]).isRequired,
  onDragEnd: PropTypes.func,
  onDragStart: PropTypes.func,
  object: PropTypes.shape({ id: PropTypes.number.isRequired }),
};
